import { render } from "./ventas.vue?vue&type=template&id=4ba17304&scoped=true&lang=es"
import script from "./ventas.vue?vue&type=script&lang=js"
export * from "./ventas.vue?vue&type=script&lang=js"

import "./ventas.vue?vue&type=style&index=0&id=4ba17304&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba17304"]])

export default __exports__